import Vue from 'vue';
import Vuex from 'vuex';

import { auth } from './authModule';

Vue.use(Vuex);

export const store = new Vuex.Store({
  modules: {
    auth
  }
});
